export class BrowserDetails {
  epmsOrderId?: String;
  userAgent?: String;
  browserLanguage?: String;
}